import { render, staticRenderFns } from "./Email-recovery.vue?vue&type=template&id=3acc4c98&"
import script from "./Email-recovery.vue?vue&type=script&lang=js&"
export * from "./Email-recovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports